function getResult(st) {
  if (!st) {
    return 0;
  }
  let p = getPlayer(st);
  if (!p) return 0;
  let d = getDivider(st);
  // if (p && p.result) return (p.result / d).toFixed(2);
  if (st && st.room && st.room.ranking) {
    for (let r of st.room.ranking) {
      if (r.playerId === p.id) {
        return (r.diff / d).toFixed(2)
      }
    }
  }
  return 0;
}

function getPlayer(state) {
  if (!state) return null;
  let pid = state.player_id;
  var k;
  if ("p1" in state) {
    for (k of ["p1", "p2", "p3"]) {
      let p = state[k];
      if (p && p.id === pid) {
        return p
      }
    }
  } else {
    for (k in state.players) {
      let p = state.players[k];
      if (p && p.id === pid) {
        return p
      }
    }
  }
  return null;
}

function getDivider(state) {
  if (!state || !state.settings) {
    return 1;
  }
  if (state.settings.withDecimal) {
    return 100;
  }
  return 1;
}

function getTime(ts) {
  if (typeof ts === 'number') {
    ts = new Date(ts * 1000);
  }
  var time = ts.toLocaleTimeString();
  var parts = time.split(" ")[0].split(':');
  return parts[0] + ":" + parts[1];
}


function bombPotInfo(st) {
  var settings = null;
  if (st && st.room && st.room.settings) {
    settings = st.room.settings;
  } else if (st && st.settings) {
    settings = st.settings;
  }
  if (!settings) {
    return {enabled: false};
  }

  if (settings.allowBombPot) {
    return {enabled: true, bb: settings.bombPotBB, every: settings.bombPotHandInterval};
  }

  return {enabled: false};
}

function baseRoomType(roomSettings) {
  let rs = roomSettings;

  if (!rs) {
    return 'Unknown';
  }

  if (rs.allinOrFold) {
    return 'AOF';
  }

  if (rs.rummy) {
    return 'Rummy';
  }

  if ("ofcType" in rs) {
    return "OFC";
  }

  if ('live' in rs && rs.live) {
    return "Live Clock";
  }

  var hilo = "";
  if (rs.hiLo) {
    hilo = " HiLo";
  }

  if (rs.roe) {
    if (rs._6Cards) {
      return "ROE PLO6" + hilo;
    }
    if (rs._5Cards) {
      return "ROE PLO5" + hilo;
    }
    return 'ROE' + hilo;
  }

  if ('omaha' in rs && rs.omaha) {
    if (rs._6Cards) {
      return "PLO6" + hilo;
    }
    if (rs._5Cards) {
      return "PLO5" + hilo;
    }
    return "PLO4" + hilo;
  }

  if ('omaha' in rs && !rs.omaha) {
    if (rs._6Plus) {
      return "Hold'em 6+";
    }
    if (rs._aof) {
      return "Hold'em AOF";
    }
    if (rs._nlh3_1) {
      return "Hold'em 3-1";
    }
    if (rs._72o) {
      return "Hold'em 72o";
    }

    return "Hold'em"
  }

  return 'Unknown';
}

function roomType(roomSettings) {
  let rs = roomSettings;

  let base = baseRoomType(rs);

  if (rs.calltimeTable) {
    return base + " (CT)";
  }

  return base;
}


export {
  getTime,
  getPlayer, getDivider, getResult,
  bombPotInfo,
  roomType,
};

